import { render } from "./EgoEditForm.vue?vue&type=template&id=54a855b6&scoped=true&ts=true"
import script from "./EgoEditForm.vue?vue&type=script&lang=ts"
export * from "./EgoEditForm.vue?vue&type=script&lang=ts"

import "./EgoEditForm.vue?vue&type=style&index=0&id=54a855b6&scoped=true&lang=css"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a855b6"]])

export default __exports__